import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["searchSection"];

  toggle(event) {
    event.preventDefault();
    this.searchSectionTarget.classList.toggle("hidden");
  }
}
